import { Action } from '@ngrx/store';
import { PicklistOption } from './picklist-option.model';

export const LIST = '[Picklist Option] List';
export const LIST_COMPLETE = '[Picklist Option] List Complete';
export const LIST_FAILED = '[Picklist Option] List Failed';

export const ADD = '[Picklist Option] Add';
export const ADD_COMPLETE = '[Picklist Option] Add Complete';
export const ADD_FAILED = '[Picklist Option] Add Failed';

export const UPDATE = '[Picklist Option] Update';
export const UPDATE_COMPLETE = '[Picklist Option] Update Complete';
export const UPDATE_FAILED = '[Picklist Option] Update Failed';

export const DELETE = '[Picklist Option] Delete';
export const DELETE_COMPLETE = '[Picklist Option] Delete Complete';
export const DELETE_FAILED = '[Picklist Option] Delete Failed';

export class ListAction implements Action {
    readonly type = LIST;

    constructor(public payload: { studioId: number, fieldId: number }) { }
}

export class ListCompleteAction implements Action {
    readonly type = LIST_COMPLETE;
    constructor(public payload: PicklistOption[]) { }
}

export class ListFailedAction implements Action {
    readonly type = LIST_FAILED;

    constructor(public payload: { error: any }) { }
}

export class AddAction implements Action {
    readonly type = ADD;

    constructor(public payload: { picklistOption: PicklistOption, studioId: number }) { }
}

export class AddCompleteAction implements Action {
    readonly type = ADD_COMPLETE;

    constructor(public payload: PicklistOption) { }
}

export class AddFailedAction implements Action {
    readonly type = ADD_FAILED;

    constructor(public payload: any) { }
}

export class UpdateAction implements Action {
    readonly type = UPDATE;

    constructor(public payload: { studioId: number, picklistOption: PicklistOption }) { }
}

export class UpdateCompleteAction implements Action {
    readonly type = UPDATE_COMPLETE;

    constructor(public payload: PicklistOption) { }
}

export class UpdateFailedAction implements Action {
    readonly type = UPDATE_FAILED;

    constructor(public payload: any) { }
}

export class DeleteAction implements Action {
    readonly type = DELETE;

    constructor(public payload: { id: number, studioId: number }) { }
}

export class DeleteCompleteAction implements Action {
    readonly type = DELETE_COMPLETE;

    constructor(public payload: number) { }
}

export class DeleteFailedAction implements Action {
    readonly type = DELETE_FAILED;

    constructor(public payload: any) { }
}

export type Actions
    = ListAction
    | ListCompleteAction
    | ListFailedAction
    | AddAction
    | AddCompleteAction
    | AddFailedAction
    | UpdateAction
    | UpdateCompleteAction
    | UpdateFailedAction
    | DeleteAction
    | DeleteCompleteAction
    | DeleteFailedAction;